import React from 'react';

export default function Privacy() {
  return (
    <main className="px-6 py-6 max-w-4xl mx-auto">
      <div className="space-y-6 text-sm leading-relaxed tracking-tight">
        <section>
          <h2 id="info-collection" className="text-base font-semibold mb-2">1. Information We Collect</h2>
          <p><strong>a. Information You Provide</strong></p>
          <ul className="list-disc list-inside space-y-1">
            <li><strong>Account Data:</strong> Name, email, hashed password, billing details.</li>
            <li><strong>Content Submissions:</strong> Text, answers, logs, and training records.</li>
          </ul>
          <p className="mt-2"><strong>b. Automatically Collected Data</strong></p>
          <ul className="list-disc list-inside space-y-1">
            <li><strong>Usage Metrics:</strong> Pages visited, question results, timestamps.</li>
            <li><strong>Device & Technical Data:</strong> IP address, browser info, device type.</li>
            <li><strong>Cookies & Tracking:</strong> Session tokens and analytics (if enabled).</li>
          </ul>
        </section>

        <section>
          <h2 id="usage" className="text-base font-semibold mb-2">2. How We Use Your Information</h2>
          <ul className="list-disc list-inside space-y-1">
            <li><strong>Skill Development:</strong> Serve questions, track mastery, personalize content.</li>
            <li><strong>Product Improvement:</strong> Analyze aggregated usage to enhance features.</li>
            <li><strong>Security:</strong> Monitor for abuse or unauthorized access attempts.</li>
            <li><strong>Communication:</strong> Transactional emails, updates, feedback requests.</li>
          </ul>
        </section>

        <section>
          <h2 id="feedback" className="text-base font-semibold mb-2">3. Skill Validation & Feedback Analysis</h2>
          <p>
            We analyze training activity to improve performance predictions and adapt future challenges.
            Your submissions are never shared publicly without consent.
          </p>
        </section>

        <section>
          <h2 id="cookies" className="text-base font-semibold mb-2">4. Cookies & Analytics</h2>
          <ul className="list-disc list-inside space-y-1">
            <li><strong>Essential Cookies:</strong> For login and user session persistence.</li>
            <li><strong>Performance Cookies:</strong> Aggregate stats to improve UX.</li>
            <li><strong>Optional:</strong> No marketing cookies used unless explicitly enabled.</li>
          </ul>
          <p className="mt-2">
            You may manage cookie preferences via browser settings or in-app options.
          </p>
        </section>

        <section>
          <h2 id="sharing" className="text-base font-semibold mb-2">5. Information Sharing</h2>
          <ul className="list-disc list-inside space-y-1">
            <li><strong>Never Sold:</strong> We do not sell or rent your data.</li>
            <li><strong>Trusted Partners:</strong> Hosting and analytics vendors under strict agreements.</li>
            <li><strong>Legal Requests:</strong> Comply with valid legal or regulatory requests.</li>
          </ul>
        </section>

        <section>
          <h2 id="security" className="text-base font-semibold mb-2">6. Data Security & Retention</h2>
          <ul className="list-disc list-inside space-y-1">
            <li><strong>Encryption:</strong> Data in transit via HTTPS; sensitive info hashed at rest.</li>
            <li><strong>Retention:</strong> Active account data kept; deleted upon request or inactivity.</li>
          </ul>
        </section>

        <section>
          <h2 id="your-rights" className="text-base font-semibold mb-2">7. Your Rights</h2>
          <p>You may request at any time:</p>
          <ul className="list-disc list-inside space-y-1">
            <li>Access or export of your data</li>
            <li>Correction or deletion</li>
            <li>Tracking opt-outs</li>
          </ul>
          <p className="mt-2">
            Reach us at <a href="mailto:privacy@mindzera.com" className="text-blue-600 hover:underline">privacy@mindzera.com</a>.
          </p>
        </section>

        <section>
          <h2 id="children" className="text-base font-semibold mb-2">8. Children’s Privacy</h2>
          <p>Mindzera is not intended for users under 16. If you believe we have collected information from a child, contact us for deletion.</p>

          <h2 id="updates" className="text-base font-semibold mt-4 mb-2">9. Policy Updates</h2>
          <p>We will update this policy as needed and notify you of material changes within the app or via email.</p>
        </section>

        <section>
          <h2 id="contact" className="text-base font-semibold mb-2">10. Contact</h2>
          <p className="space-y-1">
            Email: <a href="mailto:privacy@mindzera.com" className="text-blue-600 hover:underline">privacy@mindzera.com</a><br />
            Address: Mindzera, Inc. · 456 Precision Drive · Istanbul, Türkiye
          </p>
        </section>
      </div>
    </main>
  );
}
